import {Controller} from "stimulus";

// Watches a generating bill run without disturbing the page. Every few
// seconds (data-bill-run-status-poll-interval) it fetches the page in the
// background and compares the banner's data-bill-run-status-poll-state with
// its own; only a change reloads the page, so focus, scroll and the status
// region stay put while the run generates. The toggle target pauses and
// resumes the checks; it is a plain button whose label names what it will do.
export default class extends Controller {
    static targets = ["toggle"];

    // A page restored from Turbo's cache keeps the label it had when it was
    // cached, so the label is reset to match the checks restarting here.
    connect() {
        this.paused = false;
        this.start();
        this.updateLabel();
    }

    disconnect() {
        this.stop();
    }

    toggle() {
        this.paused = !this.paused;
        this.paused ? this.stop() : this.start();
        this.updateLabel();
    }

    updateLabel() {
        if (this.hasToggleTarget) this.toggleTarget.textContent = this.paused ? "Resume checking" : "Pause checking";
    }

    start() {
        this.timer = setInterval(() => this.check(), this.interval * 1000);
    }

    stop() {
        clearInterval(this.timer);
        this.timer = null;
    }

    async check() {
        if (this.checking) return;

        this.checking = true;
        try {
            const state = await this.fetchState();
            if (state !== null && state !== this.state && this.timer) {
                this.stop();
                this.reloadPage();
            }
        } finally {
            this.checking = false;
        }
    }

    reloadPage() {
        window.location.reload();
    }

    // The banner state on a fresh copy of the page; null when the check fails.
    async fetchState() {
        try {
            const response = await fetch(window.location.href, {headers: {Accept: "text/html"}, credentials: "same-origin"});
            if (!response.ok) return null;

            const page = new DOMParser().parseFromString(await response.text(), "text/html");
            const banner = page.getElementById(this.element.id);
            return banner ? banner.getAttribute("data-bill-run-status-poll-state") : "";
        } catch (error) {
            return null;
        }
    }

    get state() {
        return this.data.get("state");
    }

    get interval() {
        return Number(this.data.get("interval")) || 5;
    }
}
